function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1299",
  "data-name": "Rectangle 1299",
  width: 120,
  height: 120,
  fill: "none"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_719",
  "data-name": "Group 719",
  transform: "translate(30.735 26.331)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1090",
  "data-name": "Path 1090",
  d: "M514.817,295.642l-5.455,5.349a1.548,1.548,0,0,0-.107,2.158,1.437,1.437,0,0,0,1.021.491h.032a1.441,1.441,0,0,0,1.029-.4l5.519-5.421a1.543,1.543,0,0,0,0-2.129,1.44,1.44,0,0,0-2.035-.051h0Z",
  transform: "translate(-508.868 -284.617)",
  fill: "#bcd181"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1091",
  "data-name": "Path 1091",
  d: "M520.688,289.994l-5.455,5.349a1.551,1.551,0,0,0-.107,2.157,1.442,1.442,0,0,0,1.021.489h.032a1.441,1.441,0,0,0,1.029-.4l5.521-5.423a1.545,1.545,0,0,0-.01-2.129,1.439,1.439,0,0,0-2.031-.051l0,0h0Z",
  transform: "translate(-503.695 -289.595)",
  fill: "#8cb42d"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1092",
  "data-name": "Path 1092",
  d: "M514.752,321.227l-5.455,5.349a1.551,1.551,0,0,0-.107,2.157,1.452,1.452,0,0,0,1.021.491h.032a1.441,1.441,0,0,0,1.029-.4l5.519-5.421a1.545,1.545,0,0,0,0-2.131,1.44,1.44,0,0,0-2.035-.051v0h0Z",
  transform: "translate(-461.901 -262.079)",
  fill: "#bcd181"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1093",
  "data-name": "Path 1093",
  d: "M520.624,315.577l-5.455,5.349a1.551,1.551,0,0,0-.107,2.157,1.444,1.444,0,0,0,1.021.491h.032a1.449,1.449,0,0,0,1.031-.4l5.519-5.421a1.541,1.541,0,0,0-.009-2.129,1.438,1.438,0,0,0-2.033-.051h0Z",
  transform: "translate(-456.728 -267.055)",
  fill: "#8cb42d"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Group_797",
  "data-name": "Group 797",
  transform: "translate(35.738 31.976)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1171",
  "data-name": "Path 1171",
  d: "M310.781,439l-1.383-.681a2.535,2.535,0,0,1-1.27-3.066l.5-1.461a5.757,5.757,0,0,0-1.392-5.965l-2.686-2.686a5.836,5.836,0,0,0-5.966-1.39l-1.46.495a2.532,2.532,0,0,1-3.066-1.27l-.681-1.383a5.766,5.766,0,0,0-5.2-3.237h-3.8a5.766,5.766,0,0,0-5.2,3.237l-.681,1.383a2.535,2.535,0,0,1-3.066,1.27l-1.46-.5A5.854,5.854,0,0,0,268,425.146l-2.686,2.686a5.759,5.759,0,0,0-1.392,5.965l.5,1.461a2.537,2.537,0,0,1-1.27,3.066l-1.382.681a5.767,5.767,0,0,0-3.237,5.2v3.8a5.768,5.768,0,0,0,3.237,5.2l1.382.681a2.539,2.539,0,0,1,1.27,3.066l-.5,1.46a5.764,5.764,0,0,0,1.392,5.966L268,467.07a5.857,5.857,0,0,0,5.966,1.388l1.46-.5a2.561,2.561,0,0,1,1.787.075,2.48,2.48,0,0,1,1.279,1.2l.681,1.384a5.764,5.764,0,0,0,5.2,3.235h3.8a5.764,5.764,0,0,0,5.2-3.235l.683-1.384a2.506,2.506,0,0,1,1.305-1.209,2.467,2.467,0,0,1,1.759-.062l1.458.5a5.867,5.867,0,0,0,5.97-1.388l2.684-2.688a5.76,5.76,0,0,0,1.392-5.966l-.5-1.458a2.539,2.539,0,0,1,1.27-3.068l1.383-.681a5.765,5.765,0,0,0,3.237-5.2v-3.8A5.763,5.763,0,0,0,310.781,439Zm-5.329,14.267-.038-.017-.568,1.381.041.011a5.838,5.838,0,0,0,.109,3.373l.5,1.461a2.473,2.473,0,0,1-.6,2.564l-2.686,2.688a2.517,2.517,0,0,1-2.564.6l-1.461-.5a5.846,5.846,0,0,0-7.095,2.94l-.681,1.383a2.481,2.481,0,0,1-2.237,1.39h-3.8a2.479,2.479,0,0,1-2.236-1.39l-.681-1.383a5.83,5.83,0,0,0-2.315-2.468l.021-.039-1.352-.557-.017.032a5.825,5.825,0,0,0-3.433.092l-1.46.5a2.51,2.51,0,0,1-2.564-.6l-2.686-2.688a2.475,2.475,0,0,1-.6-2.564l.5-1.461a5.84,5.84,0,0,0-2.94-7.095l-1.383-.681a2.477,2.477,0,0,1-1.392-2.236v-3.8a2.475,2.475,0,0,1,1.39-2.236l1.384-.681a5.844,5.844,0,0,0,2.94-7.1l-.5-1.458a2.478,2.478,0,0,1,.6-2.566l2.686-2.686a2.5,2.5,0,0,1,2.564-.6l1.462.495a5.836,5.836,0,0,0,7.095-2.938l.681-1.384a2.479,2.479,0,0,1,2.236-1.39h3.8a2.481,2.481,0,0,1,2.237,1.39l.681,1.384a5.837,5.837,0,0,0,7.1,2.938l1.458-.495a2.51,2.51,0,0,1,2.566.6l2.686,2.686a2.474,2.474,0,0,1,.6,2.564l-.5,1.46a5.85,5.85,0,0,0,2.94,7.1l1.382.681a2.476,2.476,0,0,1,1.392,2.236v3.8a2.481,2.481,0,0,1-1.392,2.236l-1.382.681A5.8,5.8,0,0,0,305.452,453.272Z",
  transform: "translate(-258.526 -418.361)",
  fill: "#00a0af"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1172",
  "data-name": "Path 1172",
  d: "M280.36,425.072a15.123,15.123,0,1,0,15.123,15.123A15.141,15.141,0,0,0,280.36,425.072Zm11.816,15.123a11.816,11.816,0,1,1-11.816-11.816A11.831,11.831,0,0,1,292.176,440.195Z",
  transform: "translate(-252.614 -412.449)",
  fill: "#00a0af"
}));

var SvgIllustrationSettings = function SvgIllustrationSettings(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Illustration_settings",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIllustrationSettings, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Illustration_settings.67639dcb.svg";
export { ForwardRef as ReactComponent };